export const applyNowCard = {
  title: 'Join Us'
};
